<template>
    <form-container headerText="Einstellungen K.o.-Runden" :width="360" action="editRundeSettings"
                    :valid-actions="['editRundeSettings']" @save="save()">
        <div v-if="rules && runde" class="px-5 pb-3">
            <div class="grey--text text--darken-1"
                 style="font-size: 13px">Bespielte Bahnen</div>
            <v-row no-gutters>
                <v-col class="pr-3">
                    <v-text-field v-model="bahnVon" label="Von" clearable type="number" :rules="[rules.required]"/>
                </v-col>
                <v-col class="pl-3">
                    <v-text-field v-model="bahnBis" label="Bis" clearable type="number" :rules="[rules.required]"/>
                </v-col>
            </v-row>
            <!--<v-text-field v-model="startZeit" :rules="[rules.required]"
                          label="Startzeit des ersten Spiels" clearable type="time"/>-->
        </div>
    </form-container>
</template>

<script>
import FormContainer from "@/components/form/formContainer.vue";
import {FormRules} from "@/services/formRules";
import {BewerbRundeKo} from "@/services/data/meisterschaften/bewerbRundeKo";

export default {
    name: "meisterschaftRundeKoSettingsEdit",
    components: {FormContainer},
    props: ['currentData', 'bewerb'],
    computed: {
        editParam(){ return this.$route.query.action === 'editRundeSettings' },
    },
    data: () => ({
        rules: null,
        runde: null,
        error: '',
        bahnVon: null,
        bahnBis: null,
        startZeit: '00:00',
    }),
    created(){
        this.rules = new FormRules();
    },
    methods: {
        init(){
            this.runde = new BewerbRundeKo(this.currentData, null, this.currentData.settings, null)
            this.bahnVon = this.runde.settings.bahnen?.von;
            this.bahnBis = this.runde.settings.bahnen?.bis;
            this.startZeit = this.runde.settings.startZeit??'00:00';
        },
        async save(){
            this.$store.state.local.loader = true;
                this.runde.settings.bahnen.von = parseInt(this.bahnVon);
                this.runde.settings.bahnen.bis = parseInt(this.bahnBis);
                this.runde.settings.startZeit = this.startZeit;
            const reply = await this.bewerb.updateRundenSettings(this.runde);
            reply.successful ? this.handleSuccess(reply) : this.error = reply.content
            this.$store.state.local.loader = false;
        },
        handleSuccess(reply){
            console.log ("reply", reply);
            this.runde = null;
            window.history.back();
        },
    },
    watch: {
        editParam(to){ if ( to ) this.init() },
    }
}
</script>

<style scoped>

</style>